// import * as Sentry from '@sentry/browser';

export const tooltip = (elements: NodeListOf<HTMLElement>): void => {
    const CLASS_VISIBLE = 'tooltip--visible';
    elements.forEach((element) => {
        // U elementu nastavit position: relative
        element.classList.add('tooltip__parent');

        // Získat data atributy
        const position = element.dataset.tooltipPosition || 'top';
        const supportingText = element.dataset.tooltipSupportingText || '';
        const text = element.dataset.tooltip || '';

        if (text === '') {
            // Sentry.captureException('Tooltip: text nebyl nalezen');
            return;
        }

        // Vytvořit tooltip s použitím template literals
        let tooltipHTML = ``;
        tooltipHTML += `<span class="tooltip__text">${text}</span>`;

        if (supportingText !== '') {
            tooltipHTML += `<span class="tooltip__supporting-text">${supportingText}</span>`;
        }

        // Vytvořit element z HTML
        const tooltip = document.createElement('span');
        tooltip.classList.add('tooltip');
        tooltip.innerHTML = tooltipHTML;

        // Přidat tooltip do elementu
        element.appendChild(tooltip);

        // Nastavit pozici tooltipu pomocí class modifikátoru
        tooltip.classList.add(`tooltip--${position}`);

        // Přidat aria-label
        element.setAttribute('aria-label', text);

        // Při najetí myši na element zobrazit tooltip
        element.addEventListener('mouseenter', () => {
            tooltip.classList.add(CLASS_VISIBLE);
        });

        // Při odjetí myši z elementu schovat tooltip
        element.addEventListener('mouseleave', () => {
            tooltip.classList.remove(CLASS_VISIBLE);
        });
    });
};
